export class BluePrintDivision {
  id: string;
  name: string;
}

export class Division extends BluePrintDivision {
  _id: string;
}

export class ListRoleAndDivision {
  role_name: string;
  role_id: string;
  division_name: string;
  division_id: string;
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/models/division.ts